var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['container', _vm._isMobile() ? 'mobile' : ''],style:({
    background: _vm.tenantConfig.homeBgColor,
    'background-image': 'url(' + _vm.tenantConfig.homeBg + ')',
    'background-repeat': _vm.tenantConfig.homeBgRepeat,
  })},[(_vm.tenantConfig.headerType == 2)?_c('Header2',{attrs:{"id":"header"}}):(_vm.tenantConfig.headerType == 3)?_c('Header3',{attrs:{"id":"header"}}):_c('Header',{attrs:{"id":"header"}}),_c('div',{staticClass:"cms"},[_c('router-view')],1),_c('a-back-top'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }